import React from 'react';
import FilterBar from '../FilterBar/FilterBar';
import ProductFiltering from '../ProductFiltering/ProductFiltering';
import ProductListing from '../ProductListing/ProductListing';
import SearchResultLinkTab from './SearchResultLinkTab';
import styled from 'styled-components';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { grid, span } from '../../styling/utils/grid';
import { showFor } from '../../styling/utils/visibility';

const StyledColumnWrapper = styled.div`
  ${grid}

  .left {
    ${span(2)}
    ${showFor('large')}
  }
  .search-right {
    flex-grow: 1;
  }
`;

const SearchResult = (props) => {
  const { activeTab = 'products' } = useTypedSelector<any>(
    (state) => state.search
  );

  return (
    <div>
      {props.productListing?.totalProductsCount > 0 && activeTab == 'products' && (
        <StyledColumnWrapper className="layout-two-columns">
          <aside className="left">
            <ProductFiltering />
          </aside>
          <div className="search-right layout-two-columns__right">
            <FilterBar />
            <ProductListing />
          </div>
        </StyledColumnWrapper>
      )}
      {props.brandListing?.total > 0 && activeTab == 'brands' && (
        <SearchResultLinkTab items={props.brandListing.items} />
      )}
      {props.pagesListing?.total > 0 && activeTab == 'pages' && (
        <SearchResultLinkTab items={props.pagesListing.items} />
      )}
      {props.categoryListing?.total > 0 && activeTab == 'categories' && (
        <SearchResultLinkTab items={props.categoryListing.items} />
      )}
    </div>
  );
};

export default SearchResult;
